import { createContext, useContext, useEffect, useState } from "react";

const OnboardingContext = createContext(null);

const STORAGE_KEY = "vedari_onboarding_v1";

export function OnboardingProvider({ children }) {
  const [data, setData] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : { profile: {}, priorities: [], deep_dives: [], life_letter: {}, birth: {} };
    } catch {
      return { profile: {}, priorities: [], deep_dives: [], life_letter: {}, birth: {} };
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }, [data]);

  const update = (patch) => setData(d => ({ ...d, ...patch }));
  const reset = () => {
    setData({ profile: {}, priorities: [], deep_dives: [], life_letter: {}, birth: {} });
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <OnboardingContext.Provider value={{ data, update, reset }}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboarding() {
  const ctx = useContext(OnboardingContext);
  if (!ctx) throw new Error("useOnboarding must be used within OnboardingProvider");
  return ctx;
}
